// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"06430c9b","513":"f321f234"}[chunkId] + ".chunk.js";
};